<template>
  <div class="row" v-if="canRead">
    <div class="col-md-12 card">
      <div class="card-body row">
        <div class="col-sm-6">
          <p-button size="sm" icon>
            <i class="fa fa-calendar" @click="handleShowAllUsersCalendar()"></i>
          </p-button>
          <h6 style="display: inline; margin-left: 12px;">All Users Calendar</h6>
        </div>
        <div class="col-sm-6">
          <div class="pull-right form-group">
            <el-input
              type="search"
              clearable
              class="input-sm"
              style="width: 300px"
              placeholder="Search records"
              v-model="searchQuery"
              aria-controls="datatables" />
          </div>
        </div>
        <div class="col-sm-12">
          <div v-if="loading" style="text-align: center;">
            <img src="static/img/loading.gif"/>
          </div>
          <el-table class="table-striped wrap-whole-words indexed-table-column-width"
                    v-else
                    :data="queriedData"
                    :max-height="tableHeight(325)"
                    style="width: 100%">
            <el-table-column
                :width="this.constants.INDEX_COLUMN_WIDTHS.WIDE"
                align="center"
                label="#"
                type="index" />
            <el-table-column label="Name">
              <template v-slot="props">
                <a href="#" @click.prevent="handleShowEditUserModal(props.row)">{{ props.row.name }}</a>
              </template>
            </el-table-column>
            <el-table-column label="User ID">
              <template v-slot="props">
                {{ props.row.id }}
              </template>
            </el-table-column>
            <el-table-column label="Email">
              <template v-slot="props">
                {{ props.row.email }}
              </template>
            </el-table-column>
            <el-table-column label="Active" width="165">
              <template v-slot="props">
                {{ props.row.active | printBool }}
              </template>
            </el-table-column>
            <el-table-column
              width="110"
              fixed="right"
              label="Actions">
              <template v-slot="props">
                <p-button size="sm" icon>
                  <i class="fa fa-calendar" @click="handleShowUserCalendar(props.row)"></i>
                </p-button>
                <p-button type="success" size="sm" icon>
                  <i class="fa fa-edit" @click="handleShowEditUserModal(props.row)"></i>
                </p-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import PButton from 'src/components/UIComponents/Button.vue'
import Permissions from 'src/utilities/permissions'
import Constants from 'src/utilities/constants'
import {getTableHeight} from 'src/utilities/utils'
import _ from 'lodash'

export default {
  components: {
    PButton
  },
  computed: {
    ...mapGetters({
      tableData: 'users/results'
    }),
    queriedData() {
      if (!this.searchQuery) {
        return this.tableData
      }
      return this.tableData
        .filter((row) => {
          let isIncluded = false
          if (row.name) {
            const rowValue = row.name.toLowerCase()
            if (rowValue.includes && rowValue.includes(this.searchQuery.toLowerCase())) {
              isIncluded = true
            }
          }
          return isIncluded
        })
    },
    canRead() {
      return this.$can('read', Permissions.USERS)
    },
    canEdit() {
      return this.$can('edit', Permissions.USERS)
    }
  },
  data() {
    return {
      searchQuery: '',
      tableColumns: [
        {
          prop: 'name',
          label: 'Name',
          minWidth: 150,
          sortable: true
        },
        {
          prop: 'profile.email',
          label: 'Email',
          minWidth: 200,
          sortable: true
        },
        {
          prop: 'profile.mobilePhone',
          label: 'Mobile Phone',
          minWidth: 125,
          sortable: true
        },
        {
          prop: 'status',
          label: 'Status',
          minWidth: 80,
          sortable: true
        }
      ],
      constants: Constants,
      loading: false
    }
  },
  methods: {
    handleShowAllUsersCalendar() {
      this.$eventHub.$emit('show-modal-1', 'All Users Calendar', null, '95%')
    },
    handleShowUserCalendar(user) {
      this.$eventHub.$emit('show-modal-1', 'Calendar', user, '95%')
    },
    handleShowEditUserModal(user) {
      this.$eventHub.$emit('show-modal-1', 'Edit User', user, '1000px')
    },
    tableHeight(buffer) {
      return getTableHeight(buffer)
    },
    async fetchAllUsers() {
      this.loading = true
      await this.$store.cache.dispatch('users/fetchAll')
      this.loading = false
    }
  },
  beforeMount() {
    this.fetchAllUsers()
  },
  mounted() {
    this.$eventHub.$on('userUpdated', this.fetchAllUsers)
  },
  destroyed() {
    this.$eventHub.$off('userUpdated')
  }
}
</script>
